import React from 'react';
import ProductContainer from './Container';
import type { ProductCardProps } from './types';
import { ProductType } from '@/types/product';
import classNames from 'classnames';
import CardHeadVertical from './meta/card-head/card-head-vertical';
import CardBody from './meta/card-body/card-body-vertical-item-line';
import ProductAddCart from './meta/add-cart';
import EnchancedFavorite from './meta/enchanced-favorite';

const ProductVerticalItemLine: React.FC<Partial<ProductCardProps>> = props => {
  const { className, ...rest } = props;
  const data: ProductType = {
    ...props.data,
    product_tag_list: [props.data?.product_tag_list?.[0]].filter(item => !!item)
  };
  return (
    <ProductContainer
      {...rest}
      data={data}
      interactiveSlot={
        <div
          className="absolute right-0 top-0 w-full pointer-events-none"
          style={{
            paddingTop: '100%'
          }}>
          <EnchancedFavorite {...props} />
          {React.cloneElement(<ProductAddCart {...props} />, props)}
        </div>
      }>
      <div className={classNames('p-0')}>
        <CardHeadVertical {...rest} showFavorite={false} data={data}>
          {/* {React.cloneElement(<ProductAddCart {...props} />, props)} */}
        </CardHeadVertical>
        {/* Tips: product tag list 只展示一个 */}
        <CardBody {...rest} data={props.data} activityTagLimit={1} />
      </div>
    </ProductContainer>
  );
};

export default ProductVerticalItemLine;
